export default [

     {
          path: '/login',
          name: 'Login',
          component: () => import("@/views/Page/Auth/login.vue"),
           meta: {
               title: '#Default# | User',
               requiresAuth: false,
          },
     },

     {
          path: "/forgot-password",
          name: "ForgotPassword",
          component: () => import("@/views/Page/Auth/ForgotPassword.vue"),
          meta: {
               requiresAuth: false,
          },
     },
];